export function downloadCSV(data) {

  let csvRows = []; //https://gist.github.com/yangshun/01b81762e8d30f0d7f8f
  for (let i = 0; i < data.length; ++i) {
    // for (var j = 0; j < data[i].length; ++j) {
    //   data[i][j] = '\"' + data[i][j] + '\"';  // Handle elements that contain commas
    // }
    csvRows.push(data[i].join(','));
  }

  const csvContent = csvRows.join('\r\n');

// The download function takes a CSV string, the filename and mimeType as parameters
// Scroll/look down at the bottom of this snippet to see how download is called
  const download = function(content) {
    const a = document.createElement('a');
    const fileName = 'download.csv';
    const blobConfig = {
      encoding: "UTF-8",
      type: "text/plain;charset=UTF-8" // 'application/octet-stream'; // 'text/csv;encoding:utf-8'
    };
    if (navigator.msSaveBlob) { // IE10
      navigator.msSaveBlob(new Blob([content], blobConfig), fileName);
    } else if (URL && 'download' in a) { //html5 A[download]
      a.href = URL.createObjectURL(new Blob([content], blobConfig));
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
    }
  };

  download(csvContent);
}
